module.exports = "/_next/static/images/d2525eb5c1de9c28631192dd92fb25a5-phone-and-card@md-1x.jpg";